const action = require('../action/action');

const popupIframe = Object.assign({}, action, {
    modal: false,
    noHeader: false,
    noFooter: false,

    act: function () {
        
        if (this.disabled) {
            return false;
        }

        this.element.setAttribute("data-zit-indicator", "on");

        if (this.modal === false) {
            this.createModal();
        }

        this.modal.open();

        this.removeIndicator();
    },

    createModal: function () {

        let noHeader = typeof this.extraAttributes.noHeader !== typeof undefined ? this.extraAttributes.noHeader : this.noHeader;
        let noFooter = typeof this.extraAttributes.noFooter !== typeof undefined ? this.extraAttributes.noFooter : this.noFooter;

        this.modal = this.hm.newComponent('modal');
        this.modal.init({ noHeader: noHeader, noFooter: noFooter });
        this.modal.inited();

        let modalSize = typeof this.extraAttributes.modalSize !== typeof undefined ? this.extraAttributes.modalSize : 'lg';
        
        this.modal.setSize(modalSize);

        this.modal.setTitle(this.element.title);

        let iframeHtml = '<iframe class="zit-w-100 modal-iframe" src="' + this.link + '" data-backdrop="static" data-keyboard="false"></iframe>';

        let iframeElement = this.hm.helper.string2element(iframeHtml);

        this.modal.appendContent(iframeElement);
    }
});

module.exports = popupIframe